import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e5805fa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top-section"
};
const _hoisted_2 = {
  class: "search-wrapper"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "Add account", -1));
const _hoisted_4 = {
  class: "connection-page-tabs"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_input = _resolveComponent("app-input");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_AppPagination = _resolveComponent("AppPagination");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  const _component_AddAccountSideBar = _resolveComponent("AddAccountSideBar");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_omny_ui_layout, {
    contentPadding: "0 0px",
    showPagination: true
  }, {
    pagination: _withCtx(() => [_createVNode(_component_AppPagination, {
      page: $data.page,
      "onUpdate:page": _cache[2] || (_cache[2] = $event => $data.page = $event),
      perPage: $data.perPage,
      "onUpdate:perPage": [_cache[3] || (_cache[3] = $event => $data.perPage = $event), $options.updatePerPage],
      total: $data.totalPages
    }, null, 8, ["page", "perPage", "total", "onUpdate:perPage"])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_app_input, {
      class: "search-input",
      modelValue: $data.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search = $event),
      placeholder: "Search...",
      debounce: "300",
      v2: "",
      version: "search"
    }, null, 8, ["modelValue"])]), !_ctx.isOmnyWorkspace ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "add-connection-button",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.AddAccountButtonClicked && $options.AddAccountButtonClicked(...args))
    }, [_createVNode(_component_app_icon, {
      icon: "add-connection"
    }), _hoisted_3])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.currentComponent), {
      key: $data.currentTab,
      provider: $data.provider,
      page: $data.page,
      search: $data.search,
      perPage: $data.perPage,
      onUpdateTotal: $options.handleTotalUpdate
    }, null, 40, ["provider", "page", "search", "perPage", "onUpdateTotal"]))])]),
    _: 1
  }), $data.addAccountSideBar ? (_openBlock(), _createBlock(_component_AddAccountSideBar, {
    key: 0,
    modelValue: $data.addAccountSideBar,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.addAccountSideBar = $event)
  }, null, 8, ["modelValue"])) : _createCommentVNode("", true)], 64);
}